import { BaseService } from '@myhealth-raccoon/services';
import { authService } from '../auth';
import { PatientConsentExtendedModel, PatientConsentCreateModel } from './types';

class ConsentService extends BaseService {
    constructor() {
        super('v1/consent', import.meta.env.VITE_BP_API_URL);
    }

    get Authorization() {
        return authService.Authorization;
    }

    public async GetPatientConsents(consentId?: number) {
        const queryString = new URLSearchParams();
        if (consentId) {
            queryString.append('consentId', consentId.toString());
        }

        return this.get<PatientConsentExtendedModel[]>(`patient?${queryString}`);
    }

    public async AddPatientConsent(body: PatientConsentCreateModel) {
        return this.post('patient', body);
    }
}

export * from './types';
export const consentService = new ConsentService();
